import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import moment from 'moment';
import pick from 'lodash.pick';
import { querySiteTree } from '@/api/api';
import { httpAction } from '@/api/manage';
export default {
  name: "DayReportPushDrawer",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "运维日报微信推送表单",
      tableName: "om_day_report_push",
      form_fields: ['title', 'pushUserId', 'pushSiteId', 'pushHeader', 'pushTail', 'status', 'tenantId'],
      form_fields_time: ['pushTime'],
      validatorRules: {
        pushTime: {
          rules: [{
            required: true,
            message: '请选择推送时间!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入推送标题!'
          }]
        },
        pushSiteId: {
          rules: [{
            required: true,
            message: '请选择推送站点!'
          }]
        },
        pushUserId: {
          rules: [{
            required: true,
            message: '请选择推送人员!'
          }]
        },
        pushHeader: {
          rules: [{
            required: true,
            message: '请输入推送标头!'
          }]
        },
        pushTail: {
          rules: [{
            required: true,
            message: '请输入推送标尾!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择是否启用!'
          }]
        }
      },
      pushUserId: '',
      pushSiteId: '',
      wrapperCol1: {
        xs: {
          span: 4
        },
        sm: {
          span: 20
        }
      },
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 4
        }
      },
      siteTree: []
    };
  },
  props: {
    pagePath: String,
    userTree: Array
  },
  created: function created() {
    this.getSiteTree();
  },
  methods: {
    getSiteTree: function getSiteTree() {
      // 站点树
      var that = this;
      querySiteTree({
        addrType: 1
      }).then(function (res) {
        if (res.success) {
          that.siteTree = res.result;
        }
      });
    },
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'HH:mm') : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format('HH:mm') : null;
          });
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    moment: moment
  }
};